import React from "react";

/*
  @author Created by fireator-cli
  @description InviteCode Component
  Generated at Wed, 25 Nov 2020 14:39:49 GMT
*/

function InviteCode(props) {
  const { inviteCode, onDelete } = props;

  return (
    <div className="col s12 m6">
      <div className="card z-depth-0 project-summary">
        <div className="card-content grey-text text-darken-3">
<span className="company-address">Code: {inviteCode.code}</span>
{inviteCode.emailUsedInSignup ?<p className="company-address">  Email: {inviteCode.emailUsedInSignup}</p>:<p className="company-address">&nbsp;</p>}
        </div>
        <div className="card-action">
          <button onClick={(e) => onDelete(inviteCode.id, inviteCode)}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default InviteCode;
